// Builds URL-shaped metadata for track-export / track-print calls out of the
// exportContext object DataView and MapView already assemble. Field names
// mirror the query-string parameters in utils/urlRouting.js so admin
// dashboards can reason about activity_log rows with the same vocabulary as
// the client URLs.
export const buildExportMeta = (ctx, extras = {}) => {
  const c = ctx || {};
  return {
    location_name: c.locationName || null,
    location_type: c.locationType || null,
    crime_type:    c.selectedCrime || null,
    date_range:    c.selectedDateRange != null ? String(c.selectedDateRange) : null,
    data_source:   c.selectedSource || null,
    analysis_tab:  c.activeTab || null,
    view:          c.selectedView || null,
    historical:    Boolean(c.isHistorical),
    compare_scope: c.compareMode || null,
    rate_type:     c.rateViewMode || null,
    table_sort:    c.sortConfig?.key || null,
    sort_dir:      c.sortConfig?.direction || null,
    chart:         c.mapRange || c.chartOption || null,
    pop_group:     c.populationGroup || null,
    page:          c.currentPage ?? null,
    per_page:      c.itemsPerPage ?? null,
    ...extras,
  };
};
